export default __webpack_public_path__ + "static/media/defhacks_logo.5fa7e83d.svg";